import Big from 'big.js';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { Instruments, OrderUnitType, Symbols } from '../types/trade';

export interface OrderUnitInfoParams {
  marketId: string;
  instruments: Record<string, Instruments> | undefined;
  symbolsKeyby: Record<string, Symbols>;
  orderUnitType: OrderUnitType;
}

const useOrderUnitInfo = ({ marketId, instruments = {}, symbolsKeyby, orderUnitType }: OrderUnitInfoParams) => {
  const t = useTranslations('trade');

  const latestPrice = instruments[marketId]?.mark_price || '0';

  const orderUnitName = {
    '0': symbolsKeyby[marketId]?.base_currency,
    '1': t('cont'),
    '2': symbolsKeyby[marketId]?.quote_currency,
  };

  const orderUnitAmount = {
    '0': Number(symbolsKeyby[marketId]?.contract_value),
    '1': 1,
    // '2': Number(new Big(Number(latestPrice)).times(symbolsKeyby[marketId]?.contract_value).toFixed(2, 3)),
    '2': Number(new Big(Number(latestPrice)).times(symbolsKeyby[marketId]?.contract_value).toString()),
  };

  const customOrderUnitType = useMemo(() => {
    return orderUnitType === '2' ? '0' : orderUnitType;
  }, [orderUnitType]);

  const orderUnitPrecision = {
    '0': symbolsKeyby[marketId]?.contract_digit,
    '1': 0,
    '2': 2,
  };

  return {
    latestPrice,
    symbolsKeyby,
    orderUnitType,
    orderUnitName,
    orderUnitAmount,
    customOrderUnitType,
    orderUnitPrecision,
  };
};

export default useOrderUnitInfo;
